<template>
  <div class="mmain">
    <div class="wrapper">
      <div class="box">
        <div class="addInfo">
          <input placeholder="姓名" v-model="messageData.name" type="text"  />
        </div>
        <div class="addInfo">
          <input
            placeholder="工作单位"
            v-model="messageData.workaddress"
            type="text"
          />
        </div>
        <div class="addInfo">
          <input
            placeholder="联系电话"
            v-model="messageData.phone"
            type="text"
          />
        </div>
        <div class="addInfo">
          <textarea
            name=""
            placeholder="写给我们的话....."
            v-model="messageData.sug"
            id=""
            cols="30"
            rows="10"
          ></textarea>
        </div>
        <h4 @click="submit">提交内容</h4>
      </div>
    </div>
  </div>
</template>
<script>
import AllHeader from "@/components/AllHeader.vue";
import { addInfo } from "@/api/litter";
export default {
  data() {
    return {
      messageData: {
        workaddress: "",
        name: "",
        phone: "",
        sug: "",
      },
    };
  },
  mounted() {
    // window.scroll(0, 0);
  },
  methods: {
    // 留言板提交
    async submit() {
      // 手机号格式验证
      let myreg = /^[1][3,4,5,7,8][0-9]{9}$/;
      if (
        this.messageData.workaddress &&
        this.messageData.name &&
        this.messageData.phone &&
        this.messageData.sug
      ) {
        if (myreg.test(this.messageData.phone)) {
          let sData = new FormData();
          sData.append("workunit", this.messageData.workaddress);
          sData.append("name", this.messageData.name);
          sData.append("contactway", this.messageData.phone);
          sData.append("leaveword", this.messageData.sug);
          let meg = await addInfo(sData);
          if (meg.code == "OK") {
            this.$message.success("提交成功");
            this.messageData = {
              workaddress: "",
              name: "",
              phone: "",
              sug: "",
            };
            this.isShow = false;
          } else {
            this.$message.warning(meg.msg);
          }
        } else {
          this.$message.warning("联系电话格式不正确");
        }
      } else {
        this.$message.warning("有选项未填写");
      }
    },
  },
  components: {
    AllHeader,
  },
};
</script>
<style lang="less" scoped>
@color: #0687c8;
.mmain {
  width: 100%;

  .wrapper {
    width: calc(100vw - 60px);
    border-radius: 10px;
    padding: 30px 0;
    background-color: #fff;
    margin: 0 auto;
    .box {
      width: 90%;
      margin: 0 auto;
      .addInfo {
        margin: 40px 0;
        input {
          border: none #ffffff;
          border-bottom: #e6e6e6 solid 1px;
          background: transparent;
          font-size: 28px;
          width: 100%;
          padding-bottom: 20px;

          &:focus {
            outline: none;
            border: none;
            border-bottom: #ff7d48 solid 1px;
            &::-webkit-input-placeholder {
              color: #ff7d48;
              font-size: 28px;
            }
            &::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: #ff7d48;
            }

            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 */
              color: #ff7d48;
            }

            &:-ms-input-placeholder {
              /* Internet Explorer 10-11 */
              color: #ff7d48;
            }
          }
        }
        textarea {
          border: none #ffffff;
          border-bottom: #e6e6e6 solid 1px;
          background: transparent;
          font-size: 28px;
          width: 100%;

          &:focus {
            outline: none;
            border: none;
            border-bottom: #ff7d48 solid 1px;
            &::-webkit-input-placeholder {
              color: #ff7d48;
              font-size: 28px;
            }
            &::-moz-placeholder {
              /* Mozilla Firefox 19+ */
              color: #ff7d48;
            }

            &:-moz-placeholder {
              /* Mozilla Firefox 4 to 18 */
              color: #ff7d48;
            }

            &:-ms-input-placeholder {
              /* Internet Explorer 10-11 */
              color: #ff7d48;
            }
          }
        }
      }
      h3 {
        font-size: 20px;
        color: #000;
        text-align: center;
        margin: 30px 0 50px;
      }
      p {
        font-size: 14px;
        color: #666;
        margin-bottom: 15px;
      }
      .el-input {
        margin-bottom: 30px;
        width: 100%;
        height: 32px;
      }
      h4 {
        width: 185px;
        height: 50px;
        font-size: 28px;
        text-align: center;
        border-radius: 30px;
        line-height: 50px;
        background-color: @color;
        color: #ffffff;
        text-align: center;
        margin: 30px 0 30px auto;
        cursor: pointer;
      }
    }
  }
}
</style>